import { Box, Typography, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function SubjectBadge({ subject }) {
  const theme = useTheme();
  
  // Create a stable color based on subject name string
  const getColor = (name) => {
    const colors = [
      '#FF5252', '#FF4081', '#E040FB', '#7C4DFF', 
      '#536DFE', '#448AFF', '#40C4FF', '#18FFFF',
      '#64FFDA', '#69F0AE', '#B2FF59', '#EEFF41',
      '#FFFF00', '#FFD740', '#FFAB40', '#FF6E40'
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
  };

  const bg = getColor(subject);

  return (
    <Chip 
      label={subject} 
      size="small" 
      sx={{ 
        bgcolor: `${bg}20`, 
        color: bg,
        fontWeight: 600,
        borderColor: `${bg}50`,
        borderWidth: 1,
        borderStyle: 'solid'
      }} 
    />
  );
}
